angular.module('jv.Dashboard.Ajax.Service', [
    'App.ajax.service',
])
.factory('jvDashboardAjaxServiceConstant', ['$window', '$jobviteUrls', function($window, $jobviteUrls) {
    return {
        Urls: {
            //Dashboard Related
            "saveUserDashboard": $jobviteUrls.admin + '/action/dashboard/saveuserdashboard',
            // Actions Menu
            "getSourceMetrics": $jobviteUrls.jhire + '/action/user/sourceMetrics',
            "getJobviteBroadcastCount": $jobviteUrls.source + '/action/user/jobvites/list{0}',

            // My To-Do's
            "getTasks": $jobviteUrls.source + "/action/task/list",
            "getTasksCount": $jobviteUrls.source + "/action/task/list/count",
            "completeTask": $jobviteUrls.source + "/action/task/{0}",
            "getUserJobApprovals": $jobviteUrls.jhire + "/action/requisitions/search",
            "getUserOfferApprovals": $jobviteUrls.jhire + "/action/user/offer/approvals",
            "getMyPendingOfferApprovals": $jobviteUrls.jhire + "/action/user/offer/myapprovals",
            "getUserOfferApprovalDetails": $jobviteUrls.jhire + "/action/application/{0}/workflowState/{1}",
            "addWidget": $jobviteUrls.admin + "/action/widget/add",

            // My Open Jobs
            "getMyOpenJobsInfo": $jobviteUrls.jhire + "/action/requisition-workflow-group",

            //Campaigns
            "getCampaignList": $jobviteUrls.source + "/action/crm/campaigns/listWithSummary",

            //Get upcoming Interviews
            "getJobInterviewsCount": $jobviteUrls.jhire + "/action/user/jobInterviewsCount",
            "getUpcomingInterviews": $jobviteUrls.jhire + "/action/user/jobInterviews",
            "getInterviewDetail": $jobviteUrls.jhire+ "/action/{0}/jobInterviewInfo/{1}",

            //Billboard
            "getBillboardContent":  $jobviteUrls.admin + "/action/company/billboard",
            //Post Offer Approval
            "postOfferApproval": $jobviteUrls.jhire + "/action/application/{0}/approveOffer",
            //Post Job Approval
            "postJobApproval": $jobviteUrls.jhire + "/action/requisition/{0}/workflow/approve",
            //referrals
            "getReferrals":  $jobviteUrls.source + "/action/user/jobvites/apps",
            //Get My Pending Evaluations
            "getMyPendingEvaluations": $jobviteUrls.jhire + "/action/user/myevaluations",
            //Get My Pending Evaluations
            "getAllJobs": $jobviteUrls.jhire + "/action/requisitions/search",
            //Get widget list
            "getWidgetList": $jobviteUrls.admin + "/action/widget/list",
            //Get my owned jobs pending evaluations
            "getMyOwnedJobsPendingEvaluations": $jobviteUrls.jhire + "/action/user/myJobPendingEvaluations",
            "getEvaluationDetail": $jobviteUrls.jhire+ "/action/{0}/evaluationInfo/{1}",
            //Remind interviewer(s)
            "getEvaluationReminderTmpl": $jobviteUrls.jhire + "/action/application/{0}/workflowState/{1}/evaluationReminder",
            //Get TTF Prediction(s) for widget
            "getTTFPrediction": $jobviteUrls.analytics + "/widget/ttf/jobs",
            //For Demo only
            // "getTTFPrediction": "http://localhost:8888/action/widget/ttf"
            //Create new dashboard
            "createNewDashboard": $jobviteUrls.admin + "/action/dashboard/create",
            "getUserDashboards" : $jobviteUrls.admin + "/action/dashboard/list",
            //Delete dashboard
            "deleteDashboard": $jobviteUrls.admin + "/action/dashboard/{0}/delete",
            "analyticsAppTimeSeries": $jobviteUrls.jhire + '/action/application/search/facet',
            "analyticsReqStatus": $jobviteUrls.jhire + '/action/application/search/facet',
            //Get Report Bookmarks
            "getReportBookmark": $jobviteUrls.analytics + "/bookmarks/find/{0}/{1}",
            //Get Report Details
            "getReportDetails": $jobviteUrls.analytics + "/action/reports/{0}",
            "applicationAnalytics": $jobviteUrls.jhire + '/action/application/analytics/search',
            "requisitionAnalytics": $jobviteUrls.jhire + '/action/requisitions/analytics/search',
            "fetchCanvasApplicationData": $jobviteUrls.jhire + '/action/application/canvas/search',
        }
    };

}])
.service('jvDashboardAjaxService', ['$http', '$window', '$q', 'makeAjaxCall', 'jvDashboardAjaxServiceConstant',
    function($http, $window, $q, makeAjaxCall, jvDashboardAjaxServiceConstant) {

        var jvDashboardService = {};

        /**
         *  Utility for calling the ajax functions. s
         */
        function createRequestObject(args, callback, options) {
            callback = (callback || angular.noop);
            var requestObj = args || {};
            requestObj.ajaxtype = options.ajaxtype;
            requestObj.url = options.url;
            //VA: remove after writing test cases.
            //console.log(requestObj.url);
            requestObj.requestType = options.requestType || 'GET';
            requestObj.cache = options.cache || false;
            var requestPromise = makeAjaxCall(requestObj);
            requestPromise.then(function(results) {
                callback(results.data);
            });
        }

        jvDashboardService.saveUserDashboard = function(args, callback) {
            var options = {
                'ajaxtype': 'saveUserDashboard' ,
                'url': jvDashboardAjaxServiceConstant.Urls.saveUserDashboard,
                'requestType': 'POST'
            };
            args.headers = {'Content-Type': 'application/json; charset=UTF-8'};
            createRequestObject(args, callback, options);
        };

        jvDashboardService.getTasks = function(args, callback) {
            var options = {
                'ajaxtype': 'getTasksForDashboard' ,
                'url': jvDashboardAjaxServiceConstant.Urls.getTasks,
                'requestType': 'GET'
            };
            createRequestObject(args, callback, options);
        };

        jvDashboardService.getTasksCount = function(args, callback) {
            var options = {
                'ajaxtype': 'getTasksForDashboardCount' ,
                'url': jvDashboardAjaxServiceConstant.Urls.getTasksCount,
                'requestType': 'GET'
            };
            //DB-TODO
            //createRequestObject(args, callback, options);
        };

        jvDashboardService.completeTask = function(args, callback) {
            var options = {
                'ajaxtype': 'completeTaskOnDashboard',
                'url': jvDashboardAjaxServiceConstant.Urls.completeTask.format(args.id),
                'requestType': 'PUT'
            };

            delete args.id;

            createRequestObject(args, callback, options);
        };

        jvDashboardService.getUserJobApprovals = function(args, callback) {
            var options = {
                'ajaxtype': 'getUserJobApprovals',
                'url': jvDashboardAjaxServiceConstant.Urls.getUserJobApprovals,
                'requestType': 'GET'
            };

            createRequestObject(args, callback, options);
        };

        jvDashboardService.getCampaigns = function(args,callback) {
            var options = {
                'ajaxtype': 'getCampaigns',
                'url':  jvDashboardAjaxServiceConstant.Urls.getCampaignList,
                'requestType': 'GET'
            };
            createRequestObject(args, callback, options);
        };

        jvDashboardService.getUserOfferApprovals = function(args, callback) {
            var options = {
                'ajaxtype': 'getUserOfferApprovals',
                'url': jvDashboardAjaxServiceConstant.Urls.getUserOfferApprovals,
                'requestType': 'GET'
            };
            createRequestObject(args, callback, options);
        };

        jvDashboardService.getMyPendingOfferApprovals = function(args, callback) {
            var options = {
                'ajaxtype': 'getMyPendingOfferApprovals',
                'url': jvDashboardAjaxServiceConstant.Urls.getMyPendingOfferApprovals,
                'requestType': 'GET'
            };
            createRequestObject(args, callback, options);
        }

        jvDashboardService.getUserOfferApprovalDetails = function(args, callback) {
            var options = {
                'ajaxtype': 'getUserOfferApprovalDetails',
                'url': jvDashboardAjaxServiceConstant.Urls.getUserOfferApprovalDetails.format(args.applicationId,args.stateId),
                'requestType': 'GET'
            };
            delete args.applicationId;
            delete args.stateId;

            createRequestObject(args, callback, options);
        };

        var sourceRoute = $window.jvUrls.source;
        var actionRoute = $window.jvUrls.jhire + '/action';
        var adminRoute = $window.jvUrls.admin + '/action';
        var actionApplicationRoute = actionRoute + '/application';
        var actionResourcesRoute = actionRoute + '/resources';

        /* ===========================================================================
            Actions Menu
            ========================================================================== */
        jvDashboardService.getJobviteCounts = function() {
            var today = new Date();
            var priorDateOffset = new Date().setDate(today.getDate() - 30);
            var priorDate = new Date(priorDateOffset);

            var urlDateParams = '?startDate=' + encodeURIComponent(priorDate.getMonth() + '/' + priorDate.getDay() + '/' + priorDate.getFullYear()) +
            '&endDate=' + encodeURIComponent(today.getMonth() + '/' + today.getDay() + '/' + today.getFullYear());

            return $http({
                method: 'GET',
                url: (sourceRoute + '/action/user/jobvites/summary' + urlDateParams),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'}
            }).then(function (response) {
                return response.data;
            });
        };

        jvDashboardService.getJobviteBroadcastCount = function(callback) {
            var today = new Date();
            var priorDateOffset = new Date().setDate(today.getDate() - 30);
            var priorDate = new Date(priorDateOffset);
            var urlDateParams = '?messageType=BROADCAST&startDate=' + encodeURIComponent((priorDate.getMonth() + 1) + '/' + priorDate.getDay() + '/' + priorDate.getFullYear()) +
            '&endDate=' + encodeURIComponent((today.getMonth() + 1) + '/' + today.getDay() + '/' + today.getFullYear());

            var options = {
                'ajaxtype': 'getJobviteBroadcastCount',
                'url': jvDashboardAjaxServiceConstant.Urls.getJobviteBroadcastCount.format(urlDateParams),
                'requestType': 'GET'
            };
            createRequestObject(null, callback, options);
        };

        jvDashboardService.getSourceMetrics = function(args, callback) {
            var options = {
                'ajaxtype': 'getSourceMetrics',
                'url': jvDashboardAjaxServiceConstant.Urls.getSourceMetrics,
                'requestType': 'GET'
            };
            createRequestObject(args, callback, options);
        };

        /* ===========================================================================
            Upcoming  Interviews
            ========================================================================== */

        jvDashboardService.getJobInterviewsCount = function(args, callback){
             var options = {
                'ajaxtype': 'getJobInterviewsCount' ,
                'url': jvDashboardAjaxServiceConstant.Urls.getJobInterviewsCount,
                'requestType': 'GET'
            };
            createRequestObject(args, callback, options);
        };

        jvDashboardService.fetchUpcomingInterviews = function(args, callback) {
            var options = {
                'ajaxtype': 'getUpcomingInteriew' ,
                'url': jvDashboardAjaxServiceConstant.Urls.getUpcomingInterviews,
                'requestType': 'GET'
            };
            createRequestObject(args, callback, options);
        };

        jvDashboardService.getInterviewDetail = function(args, callback) {
            var params = angular.copy(args.params);
            var options = {
                'ajaxtype': 'getInterviewDetail',
                'url': jvDashboardAjaxServiceConstant.Urls.getInterviewDetail.format(params.applicationEId, params.interviewEId),
                'requestType': 'GET'
            };
            delete args.params;
            createRequestObject(args, callback, options);
        };

        jvDashboardService.getEvaluationDetail = function(args, callback) {
            var params = angular.copy(args.params);
            var options = {
                'ajaxtype': 'getEvaluationDetail',
                'url': jvDashboardAjaxServiceConstant.Urls.getEvaluationDetail.format(params.applicationEId, params.interviewEId),
                'requestType': 'GET'
            };
            delete args.params;
            createRequestObject(args, callback, options);
        };
        /************************************************************************************************************************************
         ************************************************************************************************************************************
                                                        My Open Jobs services.
        ************************************************************************************************************************************
        ************************************************************************************************************************************/

        // GET-ting my jobs info
        jvDashboardService.getMyOpenJobsInfo = function(args,callback) {
            //getMyOpenJobsInfo
            var options = {
                'ajaxtype': 'getMyOpenJobsInfo',
                'url': jvDashboardAjaxServiceConstant.Urls.getMyOpenJobsInfo,
                'requestType': 'GET'
            };
            createRequestObject(args, callback, options);
        };

        jvDashboardService.getBillboardContent = function(args,callback) {
            var options = {
                'ajaxtype': 'getBillboardContent',
                'url': jvDashboardAjaxServiceConstant.Urls.getBillboardContent,
                'requestType': 'GET'
            };
            createRequestObject(args, callback, options);
        };

        jvDashboardService.postJobApproval = function(args, callback) {
            if (!args.j) {
                return;
            }

            var options = {
                'ajaxtype': 'postJobApproval',
                'url': jvDashboardAjaxServiceConstant.Urls.postJobApproval.format(args.j),
                'requestType': 'POST'
            };

            delete args.j;
            createRequestObject(args, callback, options);
        };

        jvDashboardService.postOfferApproval = function(args, callback) {
            if (!args.appId) {
                return;
            }

            var options = {
                'ajaxtype': 'postOfferApproval',
                'url': jvDashboardAjaxServiceConstant.Urls.postOfferApproval.format(args.appId),
                'requestType': 'POST'
            };

            delete args.appId;
            createRequestObject(args, callback, options);
        };

        //Referrals widget
        jvDashboardService.getReferrals = function(args,callback) {
            var options = {
                'ajaxtype': 'getReferrals',
                'url': jvDashboardAjaxServiceConstant.Urls.getReferrals,
                'requestType': 'GET'
            };
            createRequestObject(args, callback, options);
        };

        //Report bookmark widget
        jvDashboardService.getReportBookmarks = function(args,callback) {
            var options = {
                'ajaxtype': 'getReportBookmark',
                'url': jvDashboardAjaxServiceConstant.Urls.getReportBookmark.format(args.page, args.pageSize),
                'requestType': 'GET'
            };
            createRequestObject(args, callback, options);
        };

      //Get report details
        jvDashboardService.getReportDetails = function(args,callback) {
            var options = {
                'ajaxtype': 'getReportDetails',
                'url': jvDashboardAjaxServiceConstant.Urls.getReportDetails.format(args.reportEId),
                'requestType': 'GET'
            };
            createRequestObject(args, callback, options);
        };

        //All jobs widget
        jvDashboardService.getAllJobs = function(args,callback) {
            var options = {
                'ajaxtype': 'getAllJobs',
                'url': jvDashboardAjaxServiceConstant.Urls.getAllJobs,
                'requestType': 'GET'
            };
            createRequestObject(args, callback, options);
        };

        //Pending evauations widget
        jvDashboardService.getMyPendingEvaluations = function(args, callback) {
            var options = {
                'ajaxtype': 'getMyPendingEvaluations',
                'url': jvDashboardAjaxServiceConstant.Urls.getMyPendingEvaluations,
                'requestType': 'GET'
            };
            createRequestObject(args, callback, options);
        };

        //
        jvDashboardService.getMyOwnedJobsPendingEvaluations = function(args, callback){
        	var options = {
                'ajaxtype': 'getMyOwnedJobsPendingEvaluations',
                'url': jvDashboardAjaxServiceConstant.Urls.getMyOwnedJobsPendingEvaluations,
                'requestType': 'GET'
            };
            createRequestObject(args, callback, options);
        };

        jvDashboardService.getEvaluationReminderTmpl = function(args, callback){
        	var params = angular.copy(args.params);
            var options = {
	            'ajaxtype': 'getEvaluationReminderTmpl',
	            'url': jvDashboardAjaxServiceConstant.Urls.getEvaluationReminderTmpl.format(params.applicationEId, params.candidateStateEId),
	            'requestType': 'GET'
	        };
            delete args.params;

            createRequestObject(args, callback, options);
        };

        jvDashboardService.sendEvaluationReminderTmpl = function(args, callback){
        	var params = angular.copy(args.params);
            var options = {
	            'ajaxtype': 'getEvaluationReminderTmpl',
	            'url': jvDashboardAjaxServiceConstant.Urls.getEvaluationReminderTmpl.format(params.applicationEId, params.candidateStateEId),
	            'requestType': 'POST'
	        };
            args.noTransform = true;
            args.headers = {'Content-Type':'application/json; charset=UTF-8'};
            delete args.params;

            createRequestObject(args, callback, options);
        };

        //Add Widget
        jvDashboardService.addWidget = function(args, callback) {
            var options = {
                'ajaxtype': 'addWidget',
                'url': jvDashboardAjaxServiceConstant.Urls.addWidget,
                'requestType': 'POST'
            };
            createRequestObject(args, callback, options);
        };
        //Get widget list
        jvDashboardService.getWidgetList = function(args, callback) {
            var options = {
                'ajaxtype': 'getWidgetList',
                'url': jvDashboardAjaxServiceConstant.Urls.getWidgetList,
                'requestType': 'GET'
            };
            createRequestObject(args, callback, options);
        };

        jvDashboardService.getTTFPrediction = function(args, callback) {
        	// var params = angular.copy(args.params);
            var options = {
                'ajaxtype': 'getTTFPrediction',
                'url': jvDashboardAjaxServiceConstant.Urls.getTTFPrediction,
                'requestType': 'GET'
            };
            createRequestObject(args, callback, options);
        };

        //Create new dashboard
        jvDashboardService.createNewDashboard = function(args, callback) {
            var options = {
                'ajaxtype': 'createNewDashboard',
                'url': jvDashboardAjaxServiceConstant.Urls.createNewDashboard,
                'requestType': 'POST'
            };
            createRequestObject(args, callback, options);
        };

        //Get dashboards list
        jvDashboardService.getUserDashboards = function(args, callback) {
            var options = {
                'ajaxtype': 'getUserDashboards',
                'url': jvDashboardAjaxServiceConstant.Urls.getUserDashboards,
                'requestType': 'GET'
            };
            createRequestObject(args, callback, options);
        };

        //Delete dashboard
        jvDashboardService.deleteDashboard = function(args, callback) {
            var params = angular.copy(args);
            var options = {
                'ajaxtype': 'deleteDashboard',
                'url': jvDashboardAjaxServiceConstant.Urls.deleteDashboard.format(params.id),
                'requestType': 'DELETE'
            };
            createRequestObject(args, callback, options);
        };

        //AnalyticsTimeSeries
        jvDashboardService.getAnalyticsAppTimeSeries = function(args,callback) {
            //getMyOpenJobsInfo
            var options = {
                'ajaxtype': 'getAnalyticsAppTimeSeries',
                'url': jvDashboardAjaxServiceConstant.Urls.analyticsAppTimeSeries,
                'requestType': 'GET'
            };
            createRequestObject(args, callback, options);
        };

        jvDashboardService.analyticsReqStatus = function(args,callback) {
            var options = {
                'ajaxtype': 'getAnalyticsReqStatus',
                'url': jvDashboardAjaxServiceConstant.Urls.analyticsReqStatus,
                'requestType': 'GET'
            };
            createRequestObject(args, callback, options);
        };

        jvDashboardService.applicationAnalytics = function(args, callback) {
            var options = {
                'ajaxtype': 'applicationAnalytics',
                'url': jvDashboardAjaxServiceConstant.Urls.applicationAnalytics,
                'requestType': 'POST'
            };
            args.headers = {'Content-Type':'application/json; charset=UTF-8'};
            createRequestObject(args, callback, options);
        };

        jvDashboardService.requisitionAnalytics = function(args, callback) {
            var options = {
                'ajaxtype': 'requisitionAnalytics',
                'url': jvDashboardAjaxServiceConstant.Urls.requisitionAnalytics,
                'requestType': 'POST'
            };
            args.headers = {'Content-Type':'application/json; charset=UTF-8'};
            createRequestObject(args, callback, options);
        };

        jvDashboardService.fetchCanvasApplicationData = function(args, callback) {
            var options = {
                'ajaxtype': 'fetchCanvasApplicationData',
                'url': jvDashboardAjaxServiceConstant.Urls.fetchCanvasApplicationData,
                'requestType': 'POST'
            };
            args.headers = {'Content-Type':'application/json; charset=UTF-8'};
            createRequestObject(args, callback, options);
        };

        return jvDashboardService;
}]);
